import { Component, Input, OnInit } from '@angular/core';
import { Home } from '../../interfaces/page';

@Component({
  selector: 'app-home-section-about',
  templateUrl: './home-section-about.component.html',
  styleUrls: ['./home-section-about.component.scss']
})
export class HomeSectionAboutComponent implements OnInit {
  @Input() content: Home;

  constructor() { }

  ngOnInit() {
  }

}
